<template>
  <ExActionsPopUp
      :value="value"
      :headline="`Detach Responsibility`"
      :htmlInfo="info"
      actionLabel="Detach"
      @input="$emit('input', $event)"
      @onAction="$emit('onAction')"
      data-testid="detach-position-popup"
      icon="org_icon_responsibility"
      :applyBorderClass="true"
      :width="500"
      :centerHeadline="true"
      actionsTopSpacing="32px"
  >
  </ExActionsPopUp>
</template>
<script setup>
import { computed, defineProps } from 'vue';
import ExActionsPopUp from "@components/common/ExActionsPopUp.vue";
const props = defineProps({
    value: {
      type: Boolean,
      default: false
    },
    responsibility_name: {
      type: String,
      default: ""
    },
    parent_name: {
      type: String,
      default: ""
    }
});

const info = computed(() => {
  return `<div style="margin-top: 20px;">You are about to detach responsibility ${ props.responsibility_name } from ${ props.parent_name }<br /><br /> This action will irreversibly detach all assignments to this responsibility.</div>`
});
</script>